var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenContainer -enigme1"},[(!_vm.recalled)?_c('Timer',{attrs:{"is-start":_vm.isStart},on:{"onTimeChange:end":_vm.endTime}}):_c('PhoneMessage',{attrs:{"data":_vm.dataMessages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }